<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Konfiguracja - Nowa pozycja dla zdefiniowanej faktury <small class="text-red-400 text-xs">(pola z gwiazdką są wymagane)</small></h1>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full lg:w-3/4">

        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <multiselect-input v-model="form.cykl" :error="form.errors.cykl" class="pr-6 pb-8 w-full lg:w-1/2" :options="cykle" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Domyślny cykl wystawiania dokumentu faktury *" />

            <multiselect-input v-model="form.artykul" :error="form.errors.artykul" class="pr-6 pb-8 w-full lg:w-1/2" :options="artykuly" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Domyślny artykuł na pozycji dokumentu faktury *" />

            <text-input v-model="form.vat" :error="form.errors.vat" class="pr-6 pb-8 w-full lg:w-1/3" label="VAT [%]" type="number" step="1" />

            <text-input v-model="form.ilosc" :error="form.errors.ilosc" class="pr-6 pb-8 w-full lg:w-1/3" label="Ilość" type="number" step="1" />

            <text-area-input v-model="form.opis" :error="form.errors.opis" class="pr-6 pb-8 w-full lg:w-1/2" label="Dodatkowy opis na pozycji" />

          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center" v-if="$page.props.can['update configs']">
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Zapisz konfigurację</loading-button>
          </div>
            
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextAreaInput from '@/ShtaxComponents/TextAreaInput'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Konfiguracja - Nowa pozycja dla zdefiniowanej faktury' },
  components: {
    LoadingButton,
    TextAreaInput,
    MultiselectInput,
    TextInput
  },
  layout: Layout,
  remember: 'form',
  props: {
    config: Object,
    cykle: Array,
    artykuly: Array
  },
  data() {
    return {
      form: this.$inertia.form({
        cykl: this.config.cykl,
        artykul: this.config.artykul,
        opis: this.config.opis,
        ilosc: this.config.ilosc,
        vat: this.config.vat
      })
    }
  },
  methods: {
    update() {
      this.form.put(this.route('configs.new_facture.position.update'))
    },
  },
}
</script>
